// extracted by mini-css-extract-plugin
module.exports = {"answers":"questionThree_answers__5WJPn","buttonEmoji":"questionThree_buttonEmoji__1UrWe","quizButton":"questionThree_quizButton__w18zK","active":"questionThree_active__1IBhB"};